import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          精彩看点
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          热门剧集高光片段与预告，快速了解一部剧的精彩所在
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-background-950/20 group-hover:bg-background-950/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs font-mono whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.description}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}